var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddUserRainbow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7425_11781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1828 38.2681C48.7812 36.2155 50.4508 33.0451 50.4508 29.4935C50.4508 23.3197 45.4067 18.2969 39.2066 18.2969C33.0065 18.2969 27.9623 23.3197 27.9623 29.4935C27.9623 29.8981 27.9845 30.2978 28.0267 30.6914C26.7487 29.9935 25.283 29.5958 23.7253 29.5958C18.7757 29.5958 14.749 33.6063 14.749 38.5358C14.749 41.1059 15.8452 43.4246 17.5943 45.057C13.7159 46.7598 11 50.6367 11 55.1367V65.5328C11 67.4446 12.5554 69 14.4672 69H27.0631H28.1959H51.3499C53.5657 69 55.3682 67.1974 55.3682 64.9817V51.3459C55.3682 45.3353 51.5337 40.204 46.1828 38.2681ZM39.2066 21.6953C43.5328 21.6953 47.0523 25.1936 47.0523 29.4935C47.0523 33.7934 43.5328 37.2916 39.2066 37.2916C34.8804 37.2916 31.3607 33.7934 31.3607 29.4935C31.3607 25.1936 34.8804 21.6953 39.2066 21.6953ZM23.7253 32.9942C26.801 32.9942 29.3033 35.4802 29.3033 38.5358C29.3033 38.979 29.2498 39.4187 29.1463 39.8443C27.5836 40.9076 26.2478 42.2804 25.228 43.8743C24.7417 44.0091 24.2382 44.0775 23.7253 44.0775C20.6497 44.0775 18.1475 41.5916 18.1475 38.5358C18.1475 35.4803 20.6497 32.9942 23.7253 32.9942ZM14.3984 65.5328V55.1367C14.3984 50.9437 17.8097 47.5325 22.0027 47.5325H23.5767C23.2304 48.7447 23.0449 50.024 23.0449 51.3459V64.9817C23.0449 65.1925 23.0614 65.3994 23.0928 65.6015H14.4672C14.4332 65.6015 14.3984 65.5668 14.3984 65.5328ZM51.9697 64.9817C51.9697 65.3177 51.6859 65.6015 51.3499 65.6015H28.196H27.0632C26.7272 65.6015 26.4433 65.3177 26.4433 64.9817V51.3459C26.4433 45.5542 31.1552 40.8422 36.947 40.8422H41.4661C47.2578 40.8422 51.9697 45.5542 51.9697 51.3459V64.9817Z",
    fill: "url(#paint0_linear_7425_11781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3011 15.7984H64.1779V12.6992C64.1779 11.7608 63.4171 11 62.4786 11C61.5402 11 60.7794 11.7608 60.7794 12.6992V15.7984H57.6563C56.7178 15.7984 55.957 16.5592 55.957 17.4976C55.957 18.436 56.7178 19.1968 57.6563 19.1968H60.7794V22.2961C60.7794 23.2345 61.5402 23.9953 62.4786 23.9953C63.4171 23.9953 64.1779 23.2345 64.1779 22.2961V19.1968H67.3011C68.2396 19.1968 69.0004 18.436 69.0004 17.4976C69.0004 16.5592 68.2396 15.7984 67.3011 15.7984Z",
    fill: "url(#paint1_linear_7425_11781)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7425_11781",
    x1: 55.3682,
    y1: 54.7397,
    x2: 11,
    y2: 54.7397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ABF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#6C5CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#42B2FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7425_11781",
    x1: 69.0004,
    y1: 20.3404,
    x2: 55.957,
    y2: 20.3404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ABF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#6C5CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#42B2FC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7425_11781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUserRainbow);
export default __webpack_public_path__ + "static/media/add-user-rainbow.332f327db314d2eba8a853b8cb3d3b1b.svg";
export { ForwardRef as ReactComponent };